import { render, staticRenderFns } from "./registerPage.vue?vue&type=template&id=e595c534&scoped=true"
import script from "./registerPage.vue?vue&type=script&lang=js"
export * from "./registerPage.vue?vue&type=script&lang=js"
import style0 from "./registerPage.vue?vue&type=style&index=0&id=e595c534&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e595c534",
  null
  
)

export default component.exports